const { set } = require("immutable");

function requestVisitForm() {
    
    const requestVisitBtn = document.getElementById('RequestVisit');
    const requestVisitForm = document.getElementById('RequestInfo');

    if(!requestVisitBtn || !requestVisitForm) return;

    requestVisitBtn.addEventListener('click', () => {
        

        if(!requestVisitForm )
            return;

        requestVisitForm.classList.add('request-visit');

        
    });

    requestVisitForm.addEventListener('shown.bs.offcanvas', function () {

        if( requestVisitForm.classList.contains('request-visit') ){

            let requestVisitField = document.getElementById('wsf-1-label-9-row-1');

            if(requestVisitField){

                setTimeout(function() {
                    if(!requestVisitForm.checked){
                        requestVisitField.click();
                    }
                }, 300);    

            }

            

        }
    })
   
    requestVisitForm.addEventListener('hidden.bs.offcanvas', function () {
        if( requestVisitForm.classList.contains('request-visit') ){

            let requestVisitField = document.getElementById('wsf-1-label-9-row-1');

            if(requestVisitField){

                requestVisitForm.classList.remove('request-visit');
                requestVisitField.click();
            

            }
            

        }
    })

}

document.addEventListener('DOMContentLoaded', () => {

    requestVisitForm();

}); 
